import React, { useState, useEffect } from 'react';
import {
  withStyles, Table, TableHead, TableCell, TableRow, TableBody, Button, Card, CardHeader, CardContent, Divider,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Zoom from '@material-ui/core/Zoom';
import IconButton from '@material-ui/core/IconButton';

import Edit from '@material-ui/icons/Edit';

import styles from '../assets/styles/jss/Home';
import SpeechTherapistForm from '../components/SpeechTherapistForm';
import Drawer from '../components/Drawer';
import { getSpeechSession } from '../api/axios';

import { WEEK_DAYS_REVERSE_MAPPINGS } from '../utils/constants';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      width: '100%',
      overflow: 'hidden',
    },
    margin: {
      margin: theme.spacing(2),
    },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },
    textField: {
      width: '25ch',
      padding: 0,
    },
    container: {
      width: '100%',
    // maxHeight: window.innerHeight-120,
    },
    wrapText: {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      width: '100px',
    },
  };
});

function SpeechTherapistSession() {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [result, setResult] = useState([]);
  const [editData, setEditData] = useState();

  const openModal = () => { return setOpen(true); };
  const closeModal = () => { return setOpen(false); };

  const refreshPage = () => { setRefresh(!refresh); };

  const getList = () => {
    getSpeechSession()
      .then((data) => {
        setResult(data.data);
      });
  };

  const handleEdit = (data) => {
    setEditData(data);
    setOpen(true);
  };

  useEffect(() => {
    getList();
  }, [refresh]);

  return (
    <Drawer style={{ display: 'block' }}>
      <div style={{ width: '100%', padding: '20px' }}>
        <SpeechTherapistForm
          open={open}
          onClose={() => {
            closeModal();
            getList();
          }}
          refreshPage={refreshPage}
          data={editData}
        />
        <Button variant="contained" color="primary" onClick={openModal}>
          Add Speech Therapist session
        </Button>
        <Card style={{ width: '100%', display: 'block', marginTop: '20px' }}>
          <CardHeader style={{ textAlign: 'left' }} title="Available Speech Therapist Sessions" />
          <Divider />
          <CardContent>
            <Table className={classes.root}>
              <TableHead>
                <TableRow style={{ backgroundColor: 'black' }}>
                  <TableCell><strong style={{ color: 'white' }}>Index</strong></TableCell>
                  <TableCell><strong style={{ color: 'white' }}>Week Days</strong></TableCell>
                  <TableCell><strong style={{ color: 'white' }}>Countries</strong></TableCell>
                  <TableCell><strong style={{ color: 'white' }}>Duration (in minutes)</strong></TableCell>
                  <TableCell><strong style={{ color: 'white' }}>Meeting url</strong></TableCell>
                  <TableCell><strong style={{ color: 'white' }}>Therapist image url</strong></TableCell>
                  <TableCell><strong style={{ color: 'white' }}>Therapist name</strong></TableCell>
                  <TableCell><strong style={{ color: 'white' }}>Is Active</strong></TableCell>
                  <TableCell><strong style={{ color: 'white' }}>Is Paid</strong></TableCell>
                  <TableCell><strong style={{ color: 'white' }}>Time</strong></TableCell>
                  <TableCell><strong style={{ color: 'white' }}>Edit</strong></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {
                  result && result.map((item, index) => {
                    const weekDays = item.weekDays && item.weekDays.map((date) => { return new Date(date).getDay(); });
                    const weekDayNames = (weekDays && weekDays.map((day) => { return WEEK_DAYS_REVERSE_MAPPINGS[day]; })) || [];
                    return (
                      <TableRow hover key={item._id}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>
                          <Tooltip arrow TransitionComponent={Zoom} title={weekDayNames.join(', ')}>
                            <div className={classes.wrapText}>
                              {weekDayNames.join(', ')}
                            </div>
                          </Tooltip>
                        </TableCell>
                        <TableCell>
                          <Tooltip arrow TransitionComponent={Zoom} title={item.countries && item.countries.join(', ')}>
                            <div className={classes.wrapText}>
                              {item.countries && item.countries.join(', ')}
                            </div>
                          </Tooltip>
                        </TableCell>
                        <TableCell>{item.durationMinutes}</TableCell>
                        <TableCell>
                          <Tooltip arrow TransitionComponent={Zoom} title={item.meeting_url}>
                            <div className={classes.wrapText}>
                              <a href={item.meeting_url} target="__blank">{item.meeting_url}</a>
                            </div>
                          </Tooltip>
                        </TableCell>
                        <TableCell>
                          <Tooltip arrow TransitionComponent={Zoom} title={item.therapist_image_url}>
                            <div className={classes.wrapText}>
                              <a href={item.therapist_image_url} target="__blank">{item.therapist_image_url}</a>
                            </div>
                          </Tooltip>
                        </TableCell>
                        <TableCell>{item.therapist_name}</TableCell>
                        <TableCell>{item.isActive ? 'Yes' : 'No'}</TableCell>
                        <TableCell>{item.isPaid ? 'Yes' : 'No'}</TableCell>
                        <TableCell>{new Date(item.time).toString()}</TableCell>
                        <TableCell><IconButton onClick={() => { handleEdit(item); }}><Edit /></IconButton></TableCell>
                      </TableRow>
                    );
                  })
                }
              </TableBody>
            </Table>
          </CardContent>
        </Card>
      </div>
    </Drawer>
  );
}

export default (withStyles(styles)(SpeechTherapistSession));
